module.exports = __webpack_public_path__ + "img/noinfo.9f02ca38.png";